export default __webpack_public_path__ + "static/media/wf_icon_path_animated_clear.bf93a74e.svg";